import CanvasRenderer, { RenderingStatus } from "./canvas-renderer";
export default class LoadRenderer extends CanvasRenderer {
    performRendering(data, timestamp) {
        var _a, _b;
        if ((_b = (_a = data.persist) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.returnData) {
            const returnData = data.persist.game.returnData;
            data.destination = returnData.scene;
            data.destinationPosition = returnData.position;
            data.destinationDirection = returnData.direction;
        }
        else {
            data.destination = "space";
        }
        return RenderingStatus.COMPLETED;
    }
}
